module.exports = __webpack_public_path__ + "media/images/icons/filled/qq-circle-6f6bdb086c55d9775abbd17f7cc5d2af.svg";